import { SVGProps } from "react";

export const BitbucketMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M5.72343 6.69849C5.29486 6.69849 4.93772 7.08079 5.00915 7.49785L8.04486 25.3967C8.11629 25.8486 8.50915 26.1961 9.00915 26.1961H23.5449C23.902 26.1961 24.1877 25.9528 24.2591 25.6053L27.2949 7.49785C27.3663 7.08079 27.0449 6.69849 26.5806 6.69849H5.72343ZM18.5091 19.6274H13.8663L12.6163 13.2325H19.652L18.5091 19.6274Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M26.3305 13.2327H19.6162L18.5091 19.6276H13.8662L8.36621 25.953C8.36621 25.953 8.61621 26.1963 9.00907 26.1963H23.5448C23.9019 26.1963 24.1876 25.953 24.2591 25.6055L26.3305 13.2327Z"
                fill="#1868DB"
            />
        </g>
    </svg>
);
